import { mapActions } from 'vuex';
import Events from '_utils/events';
import CommentService from '_services/rest/modules/comment';

export default {
  name: 'comment-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      CommentService.deleteComment(this.selectComment)
        .then(() => {
          this.close();
          Events.$emit('update:pagination', { page: 1 });
          this.activeAlert({ message: 'Comentário deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
